/* globals Pistor Echo Event */

import NotificationHandler from './core/NotificationHandler';

Echo.channel(`${Pistor.name}.orders`).listen('OrderCreated', ({ order }) => Event.fire('orderCreated', order));
Echo.channel(`${Pistor.name}.orders`).listen('OrderUpdated', ({ order }) => Event.fire('orderUpdated', order));
Echo.channel(`${Pistor.name}.orders`).listen('OrderDeleted', ({ order }) => Event.fire('orderDeleted', order));

Echo.channel(`${Pistor.name}.products`).listen('ProductCreated', ({ product }) => Event.fire('productCreated', product));
Echo.channel(`${Pistor.name}.products`).listen('ProductUpdated', ({ product }) => Event.fire('productUpdated', product));
Echo.channel(`${Pistor.name}.products`).listen('ProductDeleted', ({ product }) => Event.fire('productDeleted', product));

Echo.channel(`${Pistor.name}.families`).listen('FamilyCreated', ({ family }) => Event.fire('familyCreated', family));
Echo.channel(`${Pistor.name}.families`).listen('FamilyUpdated', ({ family }) => Event.fire('familyUpdated', family));
Echo.channel(`${Pistor.name}.families`).listen('FamilyDeleted', ({ family }) => Event.fire('familyDeleted', family));

Echo.channel(`${Pistor.name}.customers`).listen('CustomerCreated', ({ customer }) => Event.fire('customerCreated', customer));
Echo.channel(`${Pistor.name}.customers`).listen('CustomerUpdated', ({ customer }) => Event.fire('customerUpdated', customer));
Echo.channel(`${Pistor.name}.customers`).listen('CustomerDeleted', ({ customer }) => Event.fire('customerDeleted', customer));

Echo.channel(`${Pistor.name}.users`).listen('UserCreated', ({ user }) => Event.fire('userCreated', user));
Echo.channel(`${Pistor.name}.users`).listen('UserUpdated', ({ user }) => Event.fire('userUpdated', user));
Echo.channel(`${Pistor.name}.users`).listen('UserDeleted', ({ user }) => Event.fire('userDeleted', user));

Echo.channel(`${Pistor.name}.carts`).listen('CartCreated', ({ cart }) => Event.fire('cartCreated', cart));
Echo.channel(`${Pistor.name}.carts`).listen('CartUpdated', ({ cart }) => Event.fire('cartUpdated', cart));
Echo.channel(`${Pistor.name}.carts`).listen('CartDeleted', ({ cart }) => Event.fire('cartDeleted', cart));

Echo.channel(`${Pistor.name}.recurrences`).listen('RecurrenceCreated', ({ recurrence }) => Event.fire('recurrenceCreated', recurrence));
Echo.channel(`${Pistor.name}.recurrences`).listen('RecurrenceUpdated', ({ recurrence }) => Event.fire('recurrenceUpdated', recurrence));
Echo.channel(`${Pistor.name}.recurrences`).listen('RecurrenceDeleted', ({ recurrence }) => Event.fire('recurrenceDeleted', recurrence));

if (Pistor.user) {
  Echo.private(`${Pistor.name}.users.${Pistor.user.id}`)
    .listen('NotificationCreated', ({ notification }) => Event.fire('notificationCreated', notification));

  Echo.private(`${Pistor.name}.users.${Pistor.user.id}`)
    .listen('NotificationUpdated', ({ notification }) => Event.fire('notificationUpdated', notification));

  Echo.private(`${Pistor.name}.users.${Pistor.user.id}`)
    .notification((notification) => {
      new NotificationHandler(notification).dispatch();
    });
}
